export interface TrustpilotWidgetState {
  ready: boolean
  hasWidgetHtml: boolean
  alwaysCookieless: boolean
}

// Whether the gate shows the real TrustBox widget (vs the cookieless slot).
// The widget script is loaded by GTM, so it can only render once that script is
// ready; product-page placements stay cookieless regardless.
export function showTrustpilotWidget(s: TrustpilotWidgetState): boolean {
  return s.ready && s.hasWidgetHtml && !s.alwaysCookieless
}
